import { compose, applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { FiltersDataTransform, ActiveFeedTransform } from './transforms';

import rootReducer from './rootReducer';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: [
        'allNews',
        'favoriteNews',
        'lawsAllPublications',
        'lawsMyFavorites',
        'lawsMyActions',
        'lawsWaiting',
        'lawsAllPublicationsFilters',
        'lawsMyFavoritesFilters',
        'lawsMyActionsFilters',
        'lawsWaitingFilters',
        'digests',
        'digestsSuggestions',
        'savedScrolls'
    ],
    transforms: [FiltersDataTransform, ActiveFeedTransform]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(
    persistedReducer,
    composeEnhancers(
        applyMiddleware(thunk)
    ));

let persistor = persistStore(store);

export { store, persistor };



// WEBPACK FOOTER //
// ./src/redux_related/store.js